
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.63 14.11l-5.74-5.74a1.26 1.26 0 00-1.78 0l-5.74 5.74a1.26 1.26 0 000 1.78l5.74 5.74a1.26 1.26 0 001.78 0l5.74-5.74a1.26 1.26 0 000-1.78zM17 15.2V14h-2.5a.5.5 0 00-.5.5v3a.5.5 0 01-1 0v-3a1.5 1.5 0 011.5-1.5H17v-1.2l2 1.7z"}})])
          )
        }
      }
    